import React from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';

const Card = styled.aside`
  margin: ${p => p.theme.spacing[4]}px 0 0;
  padding: ${p => p.theme.spacing[4]}px;
  background: #FFF4E5;
  border-left: 3px solid #EF6C00;
  border-radius: 8px;
  text-align: left;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
`;

const Heading = styled.h4`
  font-size: ${p => p.theme.typography.sizes.sm};
  font-weight: ${p => p.theme.typography.weights.semibold};
  color: #8B3A00;
  margin: 0 0 ${p => p.theme.spacing[2]}px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const Icon = styled.span`
  margin-right: 6px;
`;

const Primary = styled.p`
  font-size: ${p => p.theme.typography.sizes.md};
  line-height: 1.7;
  color: #2C1810;
  margin: 0 0 ${p => p.theme.spacing[2]}px;
`;

const Secondary = styled.p`
  font-size: ${p => p.theme.typography.sizes.sm};
  line-height: 1.6;
  color: ${p => p.theme.colors.text.secondary};
  font-style: italic;
  margin: 0;
`;

const RemedySection = ({ auspiciousness, remedy_ta, remedy_en, lang = 'en' }) => {
  const t = useLocale(lang, 'ganeshaPrashnavali');

  if (auspiciousness < 4 || auspiciousness > 5) return null;
  if (!remedy_ta || !remedy_en) return null;

  const primary = lang === 'ta' ? remedy_ta : remedy_en;
  const secondary = lang === 'ta' ? remedy_en : remedy_ta;
  const heading = t.remedyHeading || 'Remedy';

  return (
    <Card aria-label={`Remedy suggestion: ${primary}`}>
      <Heading>
        <Icon aria-hidden="true">🪔</Icon>
        {heading}
      </Heading>
      <Primary>{primary}</Primary>
      {secondary && secondary !== primary && <Secondary>{secondary}</Secondary>}
    </Card>
  );
};

export default RemedySection;
